import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Reminder } from './_types';

const readOnlyFields = ['created_at', 'updated_at', '_stripePlanId', '_triggerSelectValue'];

export const normalizeReminder = (reminder): Reminder => {
  return camelcaseKeys(reminder, { deep: true }) as Reminder;
};

export const denormalizeReminder = (reminder): Reminder => {
  const decamelized = decamelizeKeys(reminder, { deep: true });

  removeReadOnlyFields(decamelized, readOnlyFields);

  // Convert content array to string for message-based automations.
  // Some action types legitimately use arrays (tags, service IDs) and must be preserved.
  const arrayContentTypes = ['client-tag', 'close-out-visit'];
  const content = decamelized.content;
  if (Array.isArray(content) && !arrayContentTypes.includes(decamelized.custom_type)) {
    decamelized.content = content[0] || '';
  }

  return {
    ...decamelized,
  } as Reminder;
};
